












import Vue from 'vue';
import { IBox } from '../../../../common/interfaces/frontpage.interface';
import BoxHeadline from './BoxHeadline.vue';
import { IStyleObject } from '../../../../common/interfaces/index.interface';

export default Vue.extend({
  name: `BoxContentOverview`,
  components: { BoxHeadline },
  computed: {
    styleObj(): IStyleObject {
      return {
        backgroundImage: `url('${this.box.backgroundImage}')`,
      };
    },
  },
  props: {
    box: {
      required: true,
      type: Object as () => IBox,
    },
    hovering: {
      required: false,
      type: Boolean,
    },
  },
});
